<template>
  <div class="Melamine">
    <div class="title">Methyl methacrylate</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Item" label="Item"> </el-table-column>
        <el-table-column prop="Index" label="Index"> </el-table-column>
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>in 190KG drum; 20'FCL=15.2MT. Or in 22 mt per 250CBM ISO tank</p>
    </div>
    <div class="item-huanhang">
      <label>Uses:</label>
      <p>
        Mainly used in the production of polymethyl methacrylate (PMIMA)
        ,acrylic resin, plastic processing additive, butyl methacrylate and
        others.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        { Item: "Appearance", Index: "Colorless Liquid" },
        { Item: "Specific Gravity(20/4℃)", Index: "0.942-0.946" },
        { Item: "Purity", Index: "99.8% Min" },
        { Item: "Water", Index: "0.05% Max" },
        { Item: "Free Acid(As MAA)", Index: "0.01% Max" },
        { Item: "APHA", Index: "10 Max" },
        {
          Item: "Topanol A / Topanol A with MEHQ",
          Index:
            "5ppm to 10ppm Topanol A (inherent) And we can dose more or dose MEHQ if customer demand.",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
